import styled from 'styled-components';

const SubTitleStyle = styled.div`
    position: relative;
    box-shadow: 0px 5px 25px 5px rgb(0 0 0 / 80%);
    background-color: rgb(0 0 0 / 100%);
    height: 100%;

    .ReactVirtualized__Table {
        div[Class=''] {
            width: 100%;
            height: 100%;
        }
        .ReactVirtualized__Grid {
            width: 100% !important; /* Force the grid to take full width */
        }
        
        .ReactVirtualized__Grid__innerScrollContainer {
            width: 100% !important; /* Force the inner container to take full width */
        }
        .imputs {
            display: block !important;
            overflow: hidden;
            overflow-y: auto;
            width: 105px !important;
            flex: 0 0 105px !important;
        }
        .imputs .content {
            line-height: normal;
            display: block;
            margin: 0px !important;
            padding: 0px !important;
            margin-top: -13px !important;
        }
        .imputs .content.ss {
            margin: -10px 0px 0px !important;
        }
        .imputs .cps_cpl {
            margin: 10px 0px 0px !important;
            display: block;
            line-height: normal;
        }
        .MuiInputBase-root.MuiInputBase-formControl input {
            border: none !important;
            padding: 0px;
        }
        .MuiOutlinedInput-notchedOutline.css-1d3z3hw-MuiOutlinedInput-notchedOutline {
            display: none;
        }
        .MuiInputLabel-formControl {
            display: none !important;
        }
        .MuiTextField-root {
            min-width: auto !important;
            margin: 0px !important;
            padding: 0px !important;
            text-align: center !important;
        }
        .MuiStack-root {
            display: block !important;
            margin: 0px !important;
            padding: 0px !important;
            text-align: center !important;
        }
        .MuiInputBase-root.MuiOutlinedInput-root {
            margin: 0px !important;
            padding: 0px !important;
            font-size: 14px !important;
            color: #fff !important;
            line-height: 15px !important;
        }
        .MuiInputBase-root.MuiOutlinedInput-root input {
            border: medium !important;
            padding: 0px;
            height: auto !important;
            text-align: center;
        }
        .public-DraftStyleDefault-block span {
            color: rgb(255, 255, 255);
            font-size: 16px !important;
            text-align: center !important;
            line-height: 22px !important;
            display: block !important;
        }
        .ReactVirtualized__Table__row {
            .item {
                height: 100%;
                width: 100%;
                padding: 5px;
                display: flex;
                flex: 1 1 0%;
                flex-direction: row;
                .textarea {
                    border: none;
                    width: 100%;
                    height: 100%;
                    color: #fff;
                    font-size: 12px;
                    padding: 5px !important;
                    text-align: center;
                    background-color: rgba(255, 255, 255, 0.05);
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    transition: all 0.2s ease;
                    resize: none;
                    outline: none;
                    &.highlight {
                        background-color: rgb(0 87 158);
                        border: 1px solid rgba(255, 255, 255, 0.3);
                        z-index: 100;
                    }
                    &.illegal {
                        background-color: rgb(123 29 0);
                        border: 1px solid rgba(255, 255, 255, 0.3);
                    }
                    &.cplYellow {
                        color: rgb(255, 255, 0);
                        border: 1px solid rgba(255, 255, 255, 0.3);
                    }
                    &.cplOrange {
                        color: rgb(218, 155, 0);
                        border: 1px solid rgba(255, 255, 255, 0.3);
                    }
                }
                .container ul {
                    padding: 0;
                    z-index: 100;
                    background-color: rgb(32, 32, 32);
                    margin-left: -50px;
                    li:first-of-type {
                        font-weight: bold;
                        color: white;
                        background-color: rgb(0 87 158);
                    }
                }
            }
            overflow: visible !important;
            height: 120px !important;
        }
    }
`;

export default SubTitleStyle;
